<template lang="pug">
.modal-card(style="width: auto")  
  header.modal-card-head
    p.modal-card-title Medium auswählen
  section.modal-card-body
    b-tabs
      b-tab-item(label="Medien")
        b-table(:data="pdfOnly ? medias.filter(m => m.isPdf) : medias.filter(m => !m.isPdf)"
                default-sort-direction="desc"
                default-sort="createdAt"
                hoverable
                @click="row => selectMedia(row.id)")
          b-table-column(label='Vorschau' v-slot="props")
            img(v-if="props.row.isPdf" src="@/assets/pdf_icon.svg" width="100px")
            img(v-else-if="props.row.thumbnailUrl" :src="props.row.thumbnailUrl")
            span(v-else) Keine Vorschau
          b-table-column(field='name' label='Name' sortable searchable v-slot="props")
            | {{props.row.name}}
          b-table-column(field='createdAt' label='erstellt am' sortable v-slot="props")
            | {{formatDate(props.row.createdAt)}}

      b-tab-item(label="Ferienobjekte" :disabled="pdfOnly")
        b-table(v-if="rentObject === null"
            :data="rentObjects"
            default-sort-direction="desc"
            default-sort="createdAt"
            hoverable
            @click="row => selectRentObject(row)")
          b-table-column(field='code' label='Code' sortable searchable v-slot="props")
            | {{props.row.code}}
          b-table-column(field='name' label='Name' sortable searchable v-slot="props")
            | {{props.row.name}}
        div(v-else)
          b-button(type="is-flat" @click="rentObject = null" icon-left="arrow-left") Zurück
          
          .label.is-small.margin-top {{rentObject.name}}
          b-table(
              v-if="rentObject.rentObjectLocations && rentObject.rentObjectLocations.thumbnailUrl"
              :data="[rentObject.rentObjectLocations]"
              default-sort-direction="desc"
              default-sort="createdAt"
              hoverable
              @click="row => selectRentObjectImage({...row, width: 1550, height: 968})")
            b-table-column(field='thumbnailUrl' label='Standort' v-slot="props")
              img(:src="props.row.thumbnailUrl")

          b-table(
              :data="rentObject.rentObjectImages"
              default-sort-direction="desc"
              default-sort="createdAt"
              hoverable
              @click="row => selectRentObjectImage(row)")
            b-table-column(field='thumbnailUrl' label='Objekt' v-slot="props")
              img(:src="props.row.thumbnailUrl")
</template>

<script>
import { DateTime } from 'luxon';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    pdfOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rentObject: null
    };
  },
  computed: {
    medias() {
      return this.$store.state.medias.all;
    },
    rentObjects() {
      return this.$store.state.rentObjects.all;
    }
  },
  methods: {
    selectMedia(id) {
      this.$emit("select", this.medias.find(m => m.id === id));
    },
    selectRentObjectImage(image) {
      this.$emit("select", image);
    },
    async selectRentObject(row) {
      let loadingComponent = this.$buefy.loading.open();
      this.rentObject = await this.$store.dispatch("rentObjects/findOne", { id: row.id });
      loadingComponent.close()
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd. LLL. yyyy hh:mm")
    }
  },
  mounted() {
    this.$store.dispatch("medias/findAll");
    this.$store.dispatch("rentObjects/findAll");
  }
}
</script>

<style lang="scss" scoped>

</style>